import { fromLonLat } from "ol/proj";

export const geoJSON = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      properties: {},
      geometry: {
        coordinates: [
          [
            fromLonLat([-56.297907560314684, -34.886433207906336]),
            fromLonLat([-56.297199990016836, -34.88986058164645]),
            fromLonLat([-56.29647747232046, -34.89307627647017]),
            fromLonLat([-56.295194107031406, -34.893308214468505]),
            fromLonLat([-56.29319844211952, -34.89494022645735]),
            fromLonLat([-56.2932160756409, -34.89553320964597]),
            fromLonLat([-56.29275760407698, -34.89598155994596]),
            fromLonLat([-56.291276388253706, -34.895518746692154]),
            fromLonLat([-56.29115295360191, -34.89488237420999]),
            fromLonLat([-56.29071211555939, -34.89426045997505]),
            fromLonLat([-56.289989141169926, -34.89426045997505]),
            fromLonLat([-56.289160021178546, -34.895021609715414]),
            fromLonLat([-56.28820574418232, -34.89413019710763]),
            fromLonLat([-56.29019382125877, -34.88541123703895]),
            fromLonLat([-56.297907560314684, -34.886433207906336]),
          ],
        ],
        type: "Polygon",
      },
    },
    {
      type: "Feature",
      properties: {},
      geometry: {
        coordinates: [
          [
            fromLonLat([-56.29061311688618, -34.87533814434185]),
            fromLonLat([-56.28855687750959, -34.88527577949855]),
            fromLonLat([-56.28028233934832, -34.890604607531394]),
            fromLonLat([-56.27705705681008, -34.898158742848956]),
            fromLonLat([-56.27820026655586, -34.8995775077439]),
            fromLonLat([-56.27911784279999, -34.8992197345596]),
            fromLonLat([-56.275853678129465, -34.90210654960053]),
            fromLonLat([-56.274454750412744, -34.901724114122445]),
            fromLonLat([-56.27403356787492, -34.900243701934386]),
            fromLonLat([-56.273416836300925, -34.89972555136469]),
            fromLonLat([-56.27323632949938, -34.89883728563891]),
            fromLonLat([-56.27204799712899, -34.89798601615094]),
            fromLonLat([-56.270573858245655, -34.898047702220424]),
            fromLonLat([-56.26917493052893, -34.89854118910895]),
            fromLonLat([-56.26794146738186, -34.894679575036115]),
            fromLonLat([-56.26786625654762, -34.8914346936496]),
            fromLonLat([-56.266948680303486, -34.89066972153512]),
            fromLonLat([-56.26393835866719, -34.88852360194825]),
            fromLonLat([-56.267081082321624, -34.87226228827592]),
            fromLonLat([-56.29061311688618, -34.87533814434185]),
          ],
        ],
        type: "Polygon",
      },
    },
    {
      type: "Feature",
      properties: {},
      geometry: {
        coordinates: [
          [
            fromLonLat([-56.26657312246559, -34.874889202468275]),
            fromLonLat([-56.266310119156586, -34.87602261844222]),
            fromLonLat([-56.25272896835109, -34.87421352613586]),
            fromLonLat([-56.25359453147945, -34.868312565922054]),
            fromLonLat([-56.25265595385429, -34.86431219659231]),
            fromLonLat([-56.25381359470815, -34.86394152114804]),
            fromLonLat([-56.25522535184656, -34.86299165769686]),
            fromLonLat([-56.25672181441348, -34.86104556173122]),
            fromLonLat([-56.26657312246559, -34.874889202468275]),
          ],
        ],
        type: "Polygon",
      },
    },
  ],
};
